import React from 'react'
import { CustomTooltip } from '../CustomTooltip/CustomTooltip'
import './buttons.css'

export const ButtonBlue = ({ onClick, style, children, placementTooltip, textTooltip, idTargetTooltip, className = '', withTooltip = false, disabled = false, type = 'button' }) => {

    return (
        <>
            {withTooltip ? <CustomTooltip placement={placementTooltip} text={textTooltip} target={idTargetTooltip} /> : null}
            <div id={idTargetTooltip} className='w-100'>
                <button
                    onClick={onClick}
                    style={style}
                    className={`btn btn-orange ${className}`}
                    disabled={disabled}
                    type={type}
                >
                    {children}
                </button>
            </div>
        </>
    )
}
